module.exports = __webpack_public_path__ + "img/hero-1.a2603c3.svg";